export { Workouts } from './Workouts';
export { WorkoutsDetail } from './Detail';
export { WorkoutsExpress } from './Express';
export { workoutsHack } from './Hack';
export { workoutsHacks } from './Hacks';
export { WorkoutsVideo } from './Video';
export { WorkoutsVideos } from './Videos';



// WEBPACK FOOTER //
// ./src/containers/Workouts/index.js